export default __webpack_public_path__ + "metro.becb061c.svg";